import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

const News = ({videos}) => {

return (
    <Box sx={{ width: '100%' }}>
    <Stack spacing={2}>
    {videos && videos.map(({ id, snippet = {} }) => {
                    const { title, description, publishedAt, thumbnails = {} } = snippet;
                    const { medium } = thumbnails;

                    const date = new Date(publishedAt)
                    const formattedDate = date.toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                        })
                    return (
                            <Card >
                            <CardMedia
                            component="img"
                            alt={medium.alt}
                            height="140"
                            image={medium.url}
                            />
                            <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                                {title}
                            </Typography>
                            <Typography gutterBottom component="div">
                                {formattedDate}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {description}
                            </Typography>
                            </CardContent>
                            <CardActions>
                            <a href={`https://www.youtube.com/watch?v=${id.videoId}`}>Watch</a>
                            </CardActions>
                        </Card>
                    )
        })}
    </Stack>
    </Box>

    );
};

export default News;